// src/pages/AllReportsPage.jsx

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fetchReports } from '../api/strapi'; // Ensure this path is correct
import Footer from '../components/Footer'; // Ensure this path is correct
import './AllReportsPage.css'; // We will update this CSS file

// Updated ReportCard component
const ReportCard = ({ report }) => {
  if (!report || !report.slug) {
    return null;
  }

  // Define a path to a real fallback image in your public folder or a URL
  const fallbackCoverImage = '/images/default-report-placeholder.png'; // EXAMPLE: Update this path

  return (
    <div className="report-card">
      <Link to={`/reports/${report.slug}`} className="report-card-inner-link">
        {/* Left Column: Image */}
        <div className="report-card-image-column">
          <img 
            src={report.coverUrl || fallbackCoverImage} 
            alt={report.headline || 'Report cover image'} 
            className="report-card-img-tag" 
            onError={(e) => { e.target.onerror = null; e.target.src=fallbackCoverImage; }} // Handle broken image links
          />
          {report.isComingSoon && <span className="coming-soon-badge">Coming Soon</span>}
        </div>

        {/* Right Column: Text Content */}
        <div className="report-card-text-column">
          {report.headline && <h3 className="report-card-headline">{report.headline}</h3>}
          {report.summary && (
            <p className="report-card-summary">
              {/* Adjust substring length as needed, or remove for full summary */}
              {report.summary.length > 200 ? `${report.summary.substring(0, 200)}...` : report.summary}
            </p>
          )}
          <span className="report-card-readmore">
            Read more <i className="fa-regular fa-arrow-right" aria-hidden="true" />
          </span>
        </div>
      </Link>
    </div>
  );
};

export default function AllReportsPage() {
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // console.log(`[${timestamp} - AllReportsPage] Fetching all reports...`); // Keep logs for debugging if needed
    setIsLoading(true);
    fetchReports()
      .then((fetchedReports) => {
        // console.log(`[${timestamp} - AllReportsPage] Reports fetched:`, fetchedReports);
        setReports(Array.isArray(fetchedReports) ? fetchedReports : []);
      })
      .catch((err) => {
        console.error('Error fetching reports for AllReportsPage:', err);
        setError(err.message || 'Failed to load reports.');
        setReports([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return <div className="page-container"><p>Loading reports...</p></div>;
  }

  if (error) {
    return <div className="page-container"><p className="error">Error loading reports: {error}</p></div>;
  }

  return (
    <>
      <div className="page-container all-reports-page">
        <header className="all-reports-header">
          <h1>Nexed Insight Reports</h1>
          <p>A growing library of research—from flagship market studies to concise insight briefs—designed to help learning leaders and providers stay informed, aligned, and ahead.</p>
        </header>

        {reports.length > 0 ? (
          <div className="reports-grid"> {/* This will remain single column */}
            {reports.map((report) => (
              <ReportCard key={report.id} report={report} />
            ))}
          </div>
        ) : (
          <p>No reports available at the moment. Please check back soon!</p>
        )}
      </div>
      <Footer />
    </>
  );
}
